module.exports = __webpack_public_path__ + "static/media/tab1.cc65ea93.png";